import Vue from 'vue'
import Vuex from 'vuex'
import {removeToken} from '../utils/auth'
import {clearWebSocket, initWebSocket} from '../socket'

Vue.use(Vuex)
function setStorage (key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}
const store = new Vuex.Store({
  state: {
    user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : '',
    siteURL: sessionStorage.getItem('siteURL') ? JSON.parse(sessionStorage.getItem('siteURL')) : '',
    loginVisible: false,
    registerFormVisible: false,
    competitionVisible: false,
    pwoerMenuIds: sessionStorage.getItem('samsungPwoerMenuIds') ? JSON.parse(sessionStorage.getItem('samsungPwoerMenuIds')) : []
  },
  mutations: {
    setPwoerMenuIds: function (state, pwoerMenuIds) {
      state.pwoerMenuIds = pwoerMenuIds
      setStorage('samsungPwoerMenuIds', state.pwoerMenuIds)
    },
    setUser: function (state, user) {
      state.user = user
      initWebSocket()
      setStorage('user', state.user)
    },
    setSiteURL: function (state, siteURL) {
      state.siteURL = siteURL
      setStorage('siteURL', state.siteURL)
    },
    loginVisibleMutations: function (state, payload) {
      state.loginVisible = payload
    },
    registerFormVisibleMutations: function (state, payload) {
      state.registerFormVisible = payload
    },
    competitionMutations: function (state, payload) {
      state.competitionVisible = payload
    },
    logout: function () {
      removeToken()
      clearWebSocket()
      sessionStorage.clear()
      location.reload()
    }
  }
})
// 导出store
export default store



// WEBPACK FOOTER //
// ./src/store/index.js